import { type Middleware, isRejectedWithValue } from "@reduxjs/toolkit";
import { toast } from "sonner";

import { formatToCapitalizedWords } from "@/lib/utils";

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    if (!navigator.onLine) {
      toast.error("Please check your internet connection.");
    } else if (
      // @ts-expect-error error msg
      action.payload.status === 401 &&
      !window.location.pathname.includes("/login")
    ) {
      toast.error("Session expired, please login again");
      localStorage.clear();
      window.location.href = "/login";
    }

    // @ts-expect-error error msg
    else if (action.payload.data) {
      // @ts-expect-error error msg
      const message = action.payload?.data?.message;
      if (
        message !==
        "No reports were found, please create daily report to see the summary."
      ) {
        // @ts-expect-error error msg
        if (action.payload.status === 409) {
          toast.info(formatToCapitalizedWords(message));
        } else {
          toast.error(
            formatToCapitalizedWords(message ?? "Something went wrong"),
          );
        }
      }
    } else {
      toast.error("Something went wrong");
    }
  }

  return next(action);
};
